<template lang="pug">
v-container( fluid pa-0 )
        v-stepper(v-model="step")
                v-stepper-header
                        v-stepper-step(
                                :complete="step > 1"
                                step="1"
                                v-if="!showEdit"
                                ) Información Oferta
                        v-divider(v-if="!showEdit")
                        v-stepper-step(
                                :complete="step > 2"
                                step="2"
                                ) Gestionar Productos
                v-stepper-items
                        v-stepper-content(step="1" v-if="!showEdit")
                                v-card
                                        v-flex.xs12
                                                CrudForm(
                                                        :fields="formFields"
                                                        no-buttons
                                                        :editable="_editableOption"
                                                        :readOnly="_readOnlyType"
                                                        ref="form"
                                                        @calculate='handleCalculate'
                                                        @submitForm="handleSubmit"
                                                        :disabled="loading"
                                                        )
                                        v-flex.xs4.offset-xs8
                                                v-btn(
                                                        block
                                                         :color="colors.secondary"
                                                        :dark="!loading"
                                                        :disabled="loading"
                                                        @click="$refs.form.submitForm()"
                                                        v-if="_massiveOfferPermission"
                                                        ) Siguiente
                                                        v-icon(right) arrow_right
                        v-stepper-content(:step="showEdit ? 1 : 2")
                                InternalCodeSearchModal(
                                    second-label='porcentaje'
                                    v-model="showModal"
                                    @product="addItem"
                                    @mode:multi="multiMode"
                                    )
                                MultiSelectSearchModal( 
                                    v-model="showMultiModal"
                                    @products="addItems"
                                    @mode:quick="quickMode"
                                    )
                                v-card
                                        span.grey--text.text--darken-2.title 
                                                | Nombre de la Oferta: 
                                                | {{showEdit ? offerName : submitData ? submitData.name : null}}
                                        v-layout.mb-4.mt-2(wrap)
                                                v-flex.xs6.pr-2
                                                        v-btn(
                                                                @click="quickMode"
                                                                block
                                                                :color="colors.secondary"
                                                                :dark="!loading"
                                                                :disabled="loading"
                                                                ) Búsqueda Rápida (F2)
                                                v-flex.xs6.pl-2
                                                        v-btn(
                                                                @click="multiMode"
                                                                block
                                                                :color="colors.secondary"
                                                                :dark="!loading"
                                                                :disabled="loading"
                                                                ) Búsqueda Múltiple (F3)
                                        span.title.grey--text.text--darken-3.actions-title
                                                | Acciones Masivas
                                        v-layout(row wrap).has-border
                                                v-flex.md4.xs6.bulk-action-area
                                                        .d-flex
                                                                v-text-field(
                                                                        suffix="%"
                                                                        v-model="bulkDiscountAmount"
                                                                        )
                                                                v-btn(
                                                                        large
                                                                        :color="colors.secondary"
                                                                        dark
                                                                        @click="bulkSetDiscount"
                                                                        ) Cambiar % de Descuento
                                                v-flex.md4.xs6.bulk-action-area
                                                        .d-flex
                                                                v-text-field(
                                                                        v-model="bulkOfferPrice"
                                                                        prefix="$")
                                                                v-btn(
                                                                        large
                                                                        :color="colors.secondary"
                                                                        dark
                                                                        @click="bulkSetOfferPrice"
                                                                        ) Cambiar Precio Oferta
                                                v-flex.md4.xs6.bulk-action-area()
                                                        v-btn(
                                                            dark
                                                            :color="colors.danger"
                                                            block 
                                                            large
                                                            @click="bulkDelete"
                                                            ) Eliminar
                                        v-data-table(
                                                :items="items"
                                                :headers="headers"
                                                hide-actions
                                                select-all
                                                item-key="id"
                                                v-model="selected"
                                                )
                                                template(slot="items" slot-scope="props")
                                                        td
                                                                v-checkbox(
                                                                    v-model="props.selected"
                                                                    hide-details
                                                                    )
                                                        td {{props.item.alias_name}}
                                                        td {{props.item.name}}
                                                        td {{props.item.upc}}
                                                        td {{props.item.sale_price | mixFormatCurrency}}
                                                        td 
                                                                v-text-field(
                                                                        v-model="props.item.discount"
                                                                        suffix="%"
                                                                        @blur="handleDiscountChange(props.item)"
                                                                        @keyup="handleDiscountChange(props.item)"
                                                                        )
                                                        td 
                                                                v-text-field(
                                                                        v-model="props.item.offer_price"
                                                                        prefix="$"
                                                                        mask="############"
                                                                        @blur="handleOfferPriceChange(props.item)"
                                                                        @keyup="handleOfferPriceChange(props.item)"
                                                                        )
                                                        td
                                                                v-btn(
                                                                        icon
                                                                        @click="removeItem(props.item)"
                                                                        )
                                                                        v-icon.red--text delete
                                        v-layout(row wrap)
                                                v-flex.xs6
                                                        v-btn(
                                                                block
                                                                :dark="!loading"
                                                                :disabled="loading"
                                                                :color="colors.secondary"
                                                                @click="step = 1"
                                                                v-if="!showEdit"
                                                                )
                                                                v-icon(left) arrow_left
                                                                span Anterior
                                                v-flex.xs6
                                                        v-btn(
                                                                block
                                                                @click="submit"
                                                                :dark="discounted.length > 0"
                                                                :disabled="!discounted.length"
                                                                :color="colors.success"
                                                                ) Guardar
                                                                v-icon(right) save
</template>

<script>
//TODO: Agregar Edit
import moment from 'moment'
import { CrudForm } from '@/components/reusable_components'
import ProductService from '@/services/api/product/ProductService'
import headers from './headers'
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils'
import axios from 'axios'
import { mapActions, mapGetters, mapState } from 'vuex'
import InternalCodeSearchModal from '@/components/ProductSearch/InternalCodeSearchModal'
import MultiSelectSearchModal from '@/components/ProductSearch/MultiSelectSearchModal'
import KeyBinds from '@/mixins/reusable_mixins/KeyBinds'
import SlGroupedOffer from '@/models/Sale/SlGroupedOffer'
import OfferService from '@/services/api/offer/OfferService'

function initialState(ctx) {
    return {
        step: 1,
        service: ProductService,
        items: [],
        headers,
        selected: [],
        bulkDiscountAmount: 0,
        bulkOfferPrice: 0,
        loading: false,
        submitData: null,

        initialDate: Date.now(),

        offerName: '',
        initDate: '',
        endDate: '',

        showModal: false,
        showMultiModal: false,

        showEdit: false,
        editedModel: null,
        itemsOfferDelete: [],
        originalIdItems: [],
        itemsToDelete: [],

        bindings: {
            f2() {
                if (ctx.loading) return
                ctx.quickMode()
            },
            f3() {
                if (ctx.loading) return
                ctx.multiMode()
            },
        },

        formFields: [
            {
                field: 'name',
                type: 'text',
                vuetifyProps: {
                    label: 'Nombre de la Oferta',
                },
                rules: ['required'],
            },
            {
                field: 'init_datetime',
                type: 'datePicker',
                vuetifyProps: {
                    label: 'Fecha Inicio',
                },                
                pickerProps: {
                    allowedDates: val => {
                        return ! moment(val).isBefore(Date.now(), 'day')
                    },
                },
                rules: ['required'],
                value: new Date().toLocaleString().split(' ').shift().split('-').reverse().join('-'),
            },
            {
                field: 'finish_datetime',
                type: 'datePicker',
                vuetifyProps: {
                    label: 'Fecha Fin',
                },               
                pickerProps: {
                    allowedDates: val => {
                        return ! moment(val).isBefore(ctx.initialDate, 'day')
                    },
                },
                rules: ['required'],
            },
        ],
    }
}

export default {
    name: 'MassiveOfferCreate',
    components: {
        CrudForm,
        InternalCodeSearchModal,
        MultiSelectSearchModal,
    },
    mixins: [CurrencyUtils, KeyBinds],
    data() {
        return initialState(this)
    },
    computed: {
        discounted() {
            return this.items.filter(i => i.sale_price !== i.offer_price)
        },
        ...mapGetters('AuthModule', { userOfficeID: 'userOfficeID' }),
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        _editableOption() {
            let isEdit = this.$route.params.id
            if (isEdit) {
                return this.$can('EDIT_SALE_OFFER')
            } else {
                return false
            }
        },
        _readOnlyType() {
            let isEdit = this.$route.params.id
            if (isEdit) {
                return !this.$can('EDIT_SALE_OFFER')
            } else {
                return false
            }
        },
        _massiveOfferPermission() {
            let isEdit = this.$route.params.id
            if (isEdit) {
                return this.$can('EDIT_MASSIVE_SALE_OFFER')
            } else {
                return this.$can('CREATE_MASSIVE_SALE_OFFER')
            }
        },
    },
    methods: {
        addItem(item) {
            if (item.quantity) item.discount = item.quantity
            if (!this.items.some(i => i.id === item.id))
                this.items.push(this.formatItem(item))
        },
        addItems(items) {
            items
                .map(i => {
                    console.log(i)
                    i.quantity = 0
                    return i
                })
                .forEach(i => this.addItem(i))
        },
        removeItem: async function(item) {
            this.items = this.items.filter(i => i.id !== item.id)
            this.itemsToDelete = [].concat(this.itemsToDelete, item.id)
            //console.log('ids to delete: ', this.itemsToDelete)
            // console.log('id delete: ', item)
            // //
            // this.resetSnackbarState()
            // this.setMessageConfirmSnack('Eliminar')

            // //
            // let payload = this.fillSnack(
            //     'warning',
            //     '¿Deseas Eliminar Item(s) Seleccionado(s)?',
            //     ''
            // )
            // this.initSnackbar(payload)
            // this.itemOffer = item
        },
        formatItem(item) {
            if (!item.discount) item.discount = 0
            if (isNaN(item.sale_price))
                //item.sale_price = item.sale_price.split('.').join('')
                item.offer_price = parseInt(item.sale_price)
            if (item.offer_price && item.offer_price % 1 !== 0) {
                item.offer_price = Math.round(item.offer_price)
                item.discount = this.calcDiscount(item)
            }
            if (item.discount) item = this.reCalc(item)
            return item
        },
        calcDiscount: item => {
            if (!item.offer_price) return 0
            return 100 - (item.offer_price * 100) / item.sale_price
        },
        reCalc: item => {
            if (!item.discount) return item.sale_price
            let offer_price = parseInt(
                item.sale_price - (item.sale_price * item.discount) / 100
            )
            let discount = 100 - (offer_price * 100) / item.sale_price
            item.discount =  discount.toFixed(2)
            item.discount = item.discount.split('.').pop() === '00' ? item.discount.split('.').shift() : item.discount
            item.offer_price = offer_price
            return item
            /*return item.sale_price - (item.sale_price * item.discount) / 100*/
        },
        handleCalculate(event) {
            this.initialDate = 0
            this.initialDate = event.vmodels.init_datetime
            console.log(this.$refs.form)
            this.$refs.form.$refs.datePickerinit_datetime.slice().pop().$forceUpdate()
        },
        handleDiscountChange(item) {
            console.log({ item })
            item = this.reCalc(item)
            this.updateItem(item)
        },
        handleOfferPriceChange(item) {
            item.discount = this.calcDiscount(item)
            this.updateItem(item)
        },
        updateItem(item) {
            this.items = this.items.map(i => {
                if (i.id === item.id) {
                    i = this.formatItem(item)
                }
                return i
            })
        },
        bulkSetDiscount() {
            if (this.selected.length<1) {
                return this.showSnackbar(
                    'info',
                    'Advertencia',
                    'Debe seleccionar producto para cambiar el porcentaje de descuento'
                )
            }
            this.selected
                .map(s => {
                    try {
                        s.discount = parseFloat(this.bulkDiscountAmount)
                    } catch (e) {
                        return
                    }
                    return s
                })
                .forEach(s => this.handleDiscountChange(s))
        },
        bulkSetOfferPrice() {
            if (this.selected.length<1) {
                return this.showSnackbar(
                    'info',
                    'Advertencia',
                    'Debe seleccionar producto para cambiar el precio oferta'
                )
            }
            this.selected
                .map(s => {
                    try {
                        s.offer_price = parseInt(this.bulkOfferPrice)
                    } catch (e) {
                        return
                    }
                    return s
                })
                .forEach(s => this.handleOfferPriceChange(s))
        },
        bulkDelete() {
            // this.selected.forEach(s => this.removeItem(s))
            let selectedItems = this.selected
            if (selectedItems.length > 0) {
                this.selected.forEach(s => this.removeItem(s))
            } else {
                this.showSnackbar(
                    'info',
                    'Advertencia',
                    'Debe seleccionar producto para eliminar'
                )
            }
        },
        async showSnackbar(
            type,
            title,
            message,
            progress = false,
            time = 3000,
            callback = () => {}
        ) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack(type, title, message, progress, time)
            )
            callback()
        },
        handleSubmit(data) {
            const stringToDate = dateString => {
                let d = dateString.split('-')
                d[1] = d[1] - 1
                return new Date(...d)
            }
            let initDate = stringToDate(data.init_datetime)
            let endDate = stringToDate(data.finish_datetime)
            if (endDate <= initDate) return this.showSnackbar('error', 'Error', 'La fecha de fin de la oferta debe ser posterior a la fecha de inicio')
            this.submitData = data
            this.step = 2
        },
        submit: async function() {
            this.loading = true
            if (this.showEdit) {
                this.submitData = {
                    init_datetime: this.initDate,
                    finish_datetime: this.endDate,
                }
                this.submitData.sl_offer_grouped_id = this.$route.params.id
                this.submitData.wh_products = this.discounted.map(
                    ({ id, offer_price }) => {
                        return { id, offer_price }
                    }
                )
                this.submitData.g_branch_office_id = this.userOfficeID
                let originalItems = [...this.originalIdItems]
                let actualItems = [
                    ...this.submitData.wh_products.map(o => o.id),
                ]
                if (originalItems.length !== actualItems.length) {
                    console.log('original_l: ', originalItems.length)
                    console.log('actual_l: ', actualItems.length)
                    if (originalItems.length > actualItems.length) {
                        this.loading = false
                        console.log('con eliminar')
                        console.log('editar items')
                        console.log('ids to delete_in: ', this.itemsToDelete)
                        console.log('ids actuales: ', this.items.map(o => o.id))
                        //-
                        let data = this.selected.map(o => o.id)
                        console.log('ids data: ', data)
                        let response = await OfferService.deleteMassiveItems({
                            sl_offers: this.itemsToDelete,
                        })
                        console.log('response: ', response)
                        if (response.status === 201) {
                            let name = this.offerName
                            let init_datetime = this.initDate
                            let finish_datetime = this.endDate
                            let sl_offers = this.discounted.map(
                                ({ id, offer_price }) => {
                                    return {
                                        id,
                                        offer_price,
                                        init_datetime,
                                        finish_datetime,
                                    }
                                }
                            )
                            let data = { sl_offers, name }
                            console.log(data)
                            const route =
                                process.env.VUE_APP_API_ROUTE +
                                '/massive_edit_offer'
                            axios
                                .patch(route, data)
                                .then(this.handleSuccess)
                                .catch(this.handleError)
                            return
                        } else {
                            this.resetSnackbarState()
                            this.handleError()
                        }
                    } else if (originalItems.length < actualItems) {
                        console.log('sin eliminar')
                        this.submitData.wh_products = this.discounted.map(
                            ({ id, offer_price }) => {
                                return { id, offer_price }
                            }
                        )
                        this.submitData.g_branch_office_id = this.userOfficeID
                        const route =
                            process.env.VUE_APP_API_ROUTE +
                            '/massive_create_offer'
                        axios
                            .post(route, this.submitData)
                            .then(this.handleSuccess)
                            .catch(this.handleError)
                    }
                    //-
                    // } else if (originalItems === actualItems) {
                    //     this.loading = false
                    //     console.log('items iguales')
                } else {
                    this.loading = false
                    console.log('sin editar')
                    console.log('original products: ', originalItems)
                    console.log('actual products: ', actualItems)
                    let name = this.offerName
                    let init_datetime = this.initDate
                    let finish_datetime = this.endDate
                    let sl_offers = this.discounted.map(
                        ({ id, offer_price }) => {
                            return {
                                id,
                                offer_price,
                                init_datetime,
                                finish_datetime,
                            }
                        }
                    )
                    let data = { sl_offers, name }
                    console.log(data)
                    const route =
                        process.env.VUE_APP_API_ROUTE + '/massive_edit_offer'
                    axios
                        .patch(route, data)
                        .then(this.handleSuccess)
                        .catch(this.handleError)
                    return
                }
                // const route =
                //     process.env.VUE_APP_API_ROUTE + '/massive_create_offer'
                // axios
                //     .post(route, this.submitData)
                //     .then(r => {
                //         let name = this.offerName
                //         let init_datetime = this.initDate
                //         let finish_datetime = this.endDate
                //         let sl_offers = this.discounted.map(
                //             ({ id, offer_price }) => {
                //                 return {
                //                     id,
                //                     offer_price,
                //                     init_datetime,
                //                     finish_datetime,
                //                 }
                //             }
                //         )
                //         let data = { sl_offers, name }
                //         console.log(data)
                //         const route =
                //             process.env.VUE_APP_API_ROUTE +
                //             '/massive_edit_offer'
                //         axios
                //             .patch(route, data)
                //             .then(this.handleSuccess)
                //             .catch(this.handleError)
                //         return
                //     })
                //     .catch(this.handleError)
            } else {
                this.submitData.wh_products = this.discounted.map(
                    ({ id, offer_price }) => {
                        return { id, offer_price }
                    }
                )
                this.submitData.g_branch_office_id = this.userOfficeID
                const route =
                    process.env.VUE_APP_API_ROUTE + '/massive_create_offer'
                axios
                    .post(route, this.submitData)
                    .then(this.handleSuccess)
                    .catch(this.handleError)
            }
        },
        deleteOfferItems: function(data) {
            const route =
                process.env.VUE_APP_API_ROUTE + '/massive_delete_offer'
            axios
                .delete(route, data)
                .then(this.handleSuccess)
                .catch(this.handleError)
            return
        },
        handleSuccess(showEdit = this.showEdit) {
            let payload = this.fillSnack(
                'success',
                'Éxito',
                showEdit
                    ? 'Oferta editada exitosamente'
                    : 'Oferta creada exitosamente'
            )
            this.resetSnackbarState()
            this.initSnackbar(payload)
            this.loading = false
            this.$router.push('/offer')
        },
        handleError(e) {
            console.log('error: ', e.response)
            let payload = this.fillSnack(
                'error',
                'Error',
                e.response ? e.response.message : 'ha ocurrido un error'
            )
            this.resetSnackbarState()
            this.initSnackbar(payload)
            this.loading = false
        },
        multiMode() {
            this.showModal = false
            this.showMultiModal = true
        },
        quickMode() {
            this.showModal = true
            this.showMultiModal = false
        },
        assignShowEditData(offer) {
            this.formFields[0].value = offer.name
            this.offerName = offer.name
            this.formFields[1].value = offer.init_datetime
            this.initDate = offer.init_datetime
            this.formFields[2].value = offer.finish_datetime
            this.endDate = offer.finish_datetime
            this.formFields = [...this.formFields]
            this.originalIdItems = offer.sl_offers.map(o => o.id)
            this.items = offer.sl_offers.map(o => {
                let p = o.wh_product
                console.log(p)
                p.id = o.id
                p.upc = o.wh_product.upc_codes.join(', ')
                p.sale_price = o.sale_price
                p.offer_price = o.offer_price
                p.discount = this.calcDiscount(p)
                //p = this.formatItem(p)
                return p
            })
        },
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
    },
    created() {
        this.setTitleTopBar('Nueva Oferta')
        if (this.$route.params.id) {
            this.showEdit = true
            let mdl = new SlGroupedOffer()
            mdl.include('sl_offers.wh_product')
                .find(this.$route.params.id)
                .then(this.assignShowEditData)
                .catch(e => console.log('error: ', e))
            this.setTitleTopBar('Editando Oferta #' + this.$route.params.id)
        }
    },
    watch: {
        async responseConfirm(val) {
            if (val === 'Eliminar') {
                this.loading = true
                this.resetSnackbarState()

                let data = this.selected.map(o => o.id)
                let response = await OfferService.deleteMassiveItems({
                    sl_offers: data,
                })
                if (response.status === 201) {
                    this.resetSnackbarState()
                    this.selected.forEach(s => {
                        this.items = this.items.filter(i => i.id !== s.id)
                    })
                    let payload = this.fillSnack(
                        'success',
                        'Éxito',
                        'Producto eliminado'
                    )
                    this.resetSnackbarState()
                    this.initSnackbar(payload)
                    this.loading = false
                } else {
                    this.resetSnackbarState()
                    this.handleError
                }
            }
        },
        showEdit: {
            immediate: true,
            handler(v) {
                console.log('showEdit', v)
                if (v) this.step = 2
                else this.step = 1
            },
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            let editOption = ctx.$route.params.id
            if (editOption) {
                if (!ctx.$can('EDIT_SALE_OFFER')) ctx.$router.push('/')
            } else if (!ctx.$can('CREATE_SALE_OFFER')) ctx.$router.push('/')
        })
    },
}
</script>

<style lang="scss" scoped>
.bulk-action-area {
    padding: 10px 15px 0px 15px;
}
.has-border {
    border: 1px solid grey;
    border-radius: 10px;
}
.actions-title {
    position: absolute;
    margin-top: -10px;
    background-color: white;
}
</style>
